import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import {
  PredictorModelState,
} from '../../../state/predictor-model/predictor-model.state';
import { Observable } from 'rxjs';
import { StatusMessage } from '../../interfaces/status-message';

@Component({
  selector: 'app-study-area-status-message',
  templateUrl: './study-area-status-message.component.html',
  styleUrl: './study-area-status-message.component.scss',
})
export class StudyAreaStatusMessageComponent {
  @Select(PredictorModelState.studyAreaStatusMessage)
  studyAreaStatusMessage$!: Observable<StatusMessage | null>;
}
